global_rootAdmin='../..';
global_rootAppli='../../..';
global_npswindow = null;

function fnAddHTTPItem(target, aData, callback) {
    var aHeaders = {},
        tagged;

    aHeaders['Content-Type']= 'text/nps';

    if (global_csrftoken)
        aData.__csrftoken = global_csrftoken;

    tagged = _.map(_.keys(aData), function(field) {
        return "<input_data><input_field>"+field+"</input_field><input_value>"+aData[field]+"</input_value></input_data>";
    });

    var oRequest = {
        info: aData,
        target: target,
        data: "<data>"+tagged.join("")+"</data>",
        callback: callback,
        headers: aHeaders,
        handlers: {
            '401': npslogout
        }
    };
    httpstack.push(oRequest);
}
function fnReLocation(url, data, unglobal) {
    var hasSearch = url.indexOf('?'),
        sep = ((hasSearch!=-1) ? '&' : '?'),
        p = _.map(data, function(v, k) {
            return k+'='+v;
        });

    if (!unglobal)
        url = global_rootAdmin+url;

    window.location.href = url+sep+p.join('&');
}

function fnPostXML(target, xml, callback) {
    var aHeaders = {};
    aHeaders['Content-Type']= 'text/xml';

    target+= (target.indexOf('?')===-1) ? '?__csrftoken='+global_csrftoken : '&__csrftoken='+global_csrftoken;

    var oRequest = {
        target: target,
        data: xml,
        callback: callback,
        headers: aHeaders,
        handlers: {
            '401': npslogout
        }
    };
    httpstack.push(oRequest);
}

function fnPostRawItem(aData, callback) {
    var tagged = _.map(_.keys(aData), function(field) {
        return "<input_data><input_field>"+field+"</input_field><input_value>"+aData[field]+"</input_value></input_data>";
    });

    var oRequest = {
        target: '/xmlvalid',
        data: "<data>"+tagged.join("")+"</data>",
        callback: callback
    };
    httpstack.push(oRequest);
}

function fnSetDocument(documentId, version) {
    var aParams={
        documentId: documentId
    };
    if (version)
        aParams.version = version;

    fnReLocation('/edition/pages/index.htm', aParams);
}
function fnSetDocument2(documentUID, version) {
    var aParams={
        docUID: documentUID
    };
    if (version)
        aParams.version = version;

    fnReLocation('/edition/pages/index.htm', aParams);
}
function fnSetDocumentFromStructure(site,structure,path,label) {
    fnReLocation('/edition/pages/index.htm', {
        type: 'structure',
        site: site,
        structure: structure,
        path: path,
        label: label
    });
}

function fnSetMoniker(xtraId, site, moniker) {
    fnReLocation('/edition/pages/index.htm', {
        type: 'moniker',
        site: site,
        moniker: moniker,
        xtraId: xtraId
    });
}

function fnSetCustom(xtraId, site, path) {
    fnReLocation(path, {
        xtraId: xtraId,
        site: site
    });
}

function fnSetStructure(site, structure) {
    fnReLocation('/structure/pages/index.htm', {
        structure: structure,
        site: site
    });
}
function fnSetLibStructure(leafId, nodeId) {
    fnReLocation('/structure/pages/index.htm', {
        objectId: leafId,
        nodeId: nodeId
    });
}

function fnSetSitewide(site, definition) {
    fnReLocation('/structure/site/index.htm', {
        definition: definition,
        site: site
    });
}


function fnSetLocalization(site, category) {
    fnReLocation('/edition/locales/index.htm', {
        category: category,
        site: site
    });
}

function fnSetLibrary(site, libraryId) {
    fnReLocation('/structure/libraries/index.htm', {
        libraryId: libraryId,
        site: site
    });
}

function fnSetNode(site, libraryId, nodeId, leafId, sortBy, sortOrder, offset, searchfield, searchval) {
    var data={
        site: site,
        libraryId: libraryId,
        nodeId: nodeId
    };

    if (leafId) data.sticky = leafId;
    if (sortBy) data.sortBy = sortBy;
    if (sortOrder) data.sortOrder = sortOrder;
    if (offset) data.offset = offset;
    if (searchfield) data.sf = searchfield;
    if (searchval) data.sv = searchval;

    var url = '/edition/libraries/index.htm';

    if ((libraryId === 'imageBank') && (window.NPS.parameters.imageBank.style === 'photolib')) {
        url = '/edition/libraries/images.htm';
    }

    fnReLocation(url, data);
}

function fnSetUsers(site) {
    fnReLocation('/users/admin/index.htm', {
        site: site
    });
}

function fnViewSite(site) {
    window.open(global_rootAdmin+'/site.htm?site='+site);
}

function fnStats(url) {
    window.open(url);
}

function fnGoHome(site) {
    fnReLocation('/index.htm', {
        site: site
    });
}

function fnHelp(page) {
    var file=global_rootAdmin+'/help/index.htm';
    window.open(file,'','scrollbars=yes,status=no,width=760,height=660,toolbars=no,resizable=yes');
}



function fnSetSite(opts) {
    fnLoadHome({site: opts.site});
}
function fnLoadHome(aParams) {
    aParams.site = aParams.site || global_site;
    fnReLocation('/index.htm', aParams);
}

function fnStackStatusChanged() {

}

function fnFireContext(oContext,oOwner,x,y,width,optionsContainer)
{
    oContext.show(oOwner,x, y,width,optionsContainer);
    return false;
}

function findPos(obj) {
    var curleft, curtop;
    curleft = curtop = 0;
    if (obj && obj.offsetParent) {
        curleft = obj.offsetLeft;
        curtop = obj.offsetTop;
        while (obj = obj.offsetParent) {
            curleft += obj.offsetLeft;
            curtop += obj.offsetTop;
        }
    }
    return [curleft, curtop];
}


$(function() {

    var $extdef = $('.externalDefinition:not(".editor-modern")');


    function redata($container) {
        return {
            source: $container.attr("source"),
            setSite: $container.attr("setSite"),
            nps: $container.attr("nps"),
            onchoose: $container.attr("onchoose"),
            objectId: $container.attr("objectId"),
            multi: $container.attr("multi"),
            duplicates: $container.attr("duplicates")
        };
    }

    $extdef.on('change', '.sourcer',function() {
        var $container=$(this).closest(".externalContainer"),
            option = $(this).attr("options")[$(this).attr("selectedIndex")];

        var data=redata($container);
        data.nps = option.nps;
        data.setSite = option.site;

        wndLibraryChooseLoad($(this).closest(".externalDefinition"), data);
    });


    $extdef.on('click', '.noder', function(e) {
        e.preventDefault();
        var $container = $(this).closest(".externalContainer"),
            data = redata($container);

        data.nodeId = $(this).attr("nodeId");

        wndLibraryChooseLoad($(this).closest(".externalDefinition"),data);
    });

    $extdef.on('click', '.offsetter', function() {
        var $ext=$(this).closest(".externalContainer"),
            $zone=$(".searchZone", $ext),
            $field=$(".searchField", $zone),
            $textedit=$(".searchValue", $zone);

        var data=redata($ext);
        data.nodeId = $ext.attr("nodeId");
        data.offset = $(this).attr("offset");
        data.sf = $field.val();
        data.sv = $textedit.html();

        wndLibraryChooseLoad($(this).closest(".externalDefinition"),data);
        return false;
    });

    $extdef.on('click', '.chooser',function() {
        var oSandbox=$(this).closest(".externalDefinition").find(".externalContainer-selection");
        var oSelected=$(this).closest("*[objectId]");
        if (oSelected.length===0) oSelected=$(this).closest(".chooser");
        var $container=$(this).closest(".externalContainer");

        $container.attr("data-info", oSelected.attr("data-info"));
        $container.attr("data-details", {});

        var oClone=oSelected.clone();
        oClone.removeClass("chooser");
        oClone.addClass("chosen");


        if ($container.attr("multi") === 'y') {
            if (($container.attr("duplicates")==='n') && (oSandbox.find('.chosen[objectId="'+this.objectId+'"]').length))
                return;

            oSandbox.append( oClone );

            var ids = [];
            oSandbox.find('.chosen').each(function() {
                ids.push($(this).attr("objectId"));
            });
            $container.attr("objectId", ids.join('-'));
        } else {
            $container.attr("objectId", oSelected.attr("objectId"));
            oSandbox.empty();
            oSandbox.prepend( oClone );
        }

        $container.find('.Buttons').removeClass('off');

        if ($container.attr("onchoose")) {
            var $details = $('<div></div>');
            oSandbox.append($details);
            $.get($container.attr("onchoose"),{objectId: $container.attr("objectId")}, function(data) {
                $details.html(data);
            });
        }
    });

    $extdef.on('click', 'a.fields', function(e) {
        e.preventDefault();
        var $target = $(this).closest(".externalDefinition");

        $.get($(this).attr('href'), function(data) {
            $target.html(data);
            $target.show();
            fnInitFields($target.get(0));
        });
    });


    $extdef.on('click', '.chosen', function(e) {
        var $chosen = $(this),
            $container = $chosen.closest(".externalContainer"),
            $def = $chosen.closest(".externalDefinition"),
            $sandbox = $def.find(".externalContainer-selection");

        e.stopPropagation();

        if ($container.attr("multi") === 'y') {
            var oCtrl = NPSContext.get('libpick', {
                queryContext: function(ctx, opts) {
                    switch (ctx) {
                        case 'move':
                            if (opts.delta==='-1')
                                return $chosen.prev('.chosen').length>0;
                            return $chosen.next('.chosen').length>0;

                        default:
                            return true;
                    }
                },
                actions: {
                    remove: function() {
                        $chosen.remove();

                        var ids = [];
                        $sandbox.find('.chosen').each(function() {
                            ids.push($(this).attr("objectId"));
                        });
                        $container.attr("objectId", ids.join('-'));
                    },
                    move: function(opts) {
                        var delta = opts.delta,
                            elm1, elm2,
                            parent1, next1,
                            parent2, next2;

                        elm1 = $chosen.get(0);
                        elm2 = (delta>0) ? $chosen.next('.chosen').get(0) : $chosen.prev('.chosen').get(0);

                        parent1 = elm1.parentNode;
                        next1   = elm1.nextSibling;
                        parent2 = elm2.parentNode;
                        next2   = elm2.nextSibling;

                        parent1.insertBefore(elm2, next1);
                        parent2.insertBefore(elm1, next2);

                        var ids = [];
                        $sandbox.find('.chosen').each(function() {
                            ids.push($(this).attr("objectId"));
                        });
                        $container.attr("objectId", ids.join('-'));
                    }
                }
            });
            oCtrl.show({
                width: 150,
                position: {
                   left: e.pageX,
                   top: e.pageY
                }
            });

        } else {
            $container.attr("objectId","");
            $container.attr("data-info","");
            $sandbox.empty();
        }
    });
    $extdef.on('mouseover', '.item', function() {
        $(this).addClass("over");
    });
    $extdef.on('mouseout', '.item', function() {
        $(this).removeClass("over");
    });


    $extdef.on('click', '.closer', function(e) {
        e.preventDefault();
        var $def=$(this).closest(".externalDefinition");

        $def.unbind('choice.nps');
        $def.empty();
        $def.hide();
    });
    $extdef.on('click', '[data-action="commit"]', function(e) {
        e.preventDefault();

        var $container = $(this).closest(".externalContainer"), $def=$(this).closest(".externalDefinition");

        var data= $container.attr("data-info") ? $.parseJSON($container.attr("data-info")):{};

        data.nps=$container.attr("nps");
        data.objectId=$container.attr("objectId") || '';
        data.details=$container.attr("data-details");
        data.representation=$container.find('.externalContainer-selection').html();

        $def.trigger('choice.nps', data);

        $def.unbind('choice.nps');
        $def.empty();
        $def.hide();
    });

    $extdef.on('change', '.searchField', function() {
        var sfield=$(this).val(), $zone=$(this).closest(".searchZone"), $container=$(".searchContainers", $zone), $specedit=$(".searchValue-"+sfield, $container);

        $("div", $container).hide();

        if ($specedit.length)
            $specedit.show();
        else
            $(".searchValue", $container).show();
    });


    var searchinzone = function(e) {
        e.preventDefault();

        var $ext= $(this).closest(".externalContainer"),
            $zone = $(this).closest('form').find(".searchZone"),
            $field = $zone.find(".searchField"),
            $textedit=$zone.find(".searchValue");

        var data = redata($ext);
        data.sf = $field.val();
        data.sv = $textedit.val();
        data.nodeId = $ext.attr("nodeId");

        wndLibraryChooseLoad($(this).closest(".externalDefinition"), data);
    }

    //$extdef.on('click', '.searchZone button', searchinzone);
    $extdef.on('submit', 'form', searchinzone);
});

var wndLibraryChooseLoad=function(target,ps, callback) {
    wndGenericChooseLoad(target, global_rootAdmin+'/edition/pages/externals/libraryPick/generic.htm', ps, callback);
};

var wndGenericChooseLoad = function(target, url, ps, callback) {
    $.get(url, ps, function(data) {
        var $target = $(target);
        var $fields, $items, $tree,
            h, baseh = $target.height();

        $target.html(data);
        $target.show();

        baseh = baseh - parseInt($target.find('.externalHeader').height(), 10);

        $fields = $target.find('.searchField');
        if ($fields.find('option').length<2)
            $fields.hide();

        $items = $target.find('.externalContainer-items');
        h = baseh;
        if ($items.length)
            h = h - parseInt($items.get(0).offsetTop, 10);
        $items.css({height: h+"px"});

        $tree = $target.find('.externalContainer-tree');
        h = baseh;
        if ($tree.length)
            h = h - parseInt($tree.get(0).offsetTop, 10);
        $tree.css({height: h+"px"});

        if (callback) callback();
        recenterElement(target);
    });
};


function recenterElement(el) {
    var $el = $(el),
        h = $el.get(0).height;
    if (h) $el.css({height: h+'px'});

    var win = $(window),
        winW = win.width(),
        winH = win.height(),
        scrollTop = win.scrollTop(),
        scrollLeft = win.scrollLeft(),
        contW = $el.width(),
        contH = $el.height(),
        left = (winW-contW)/2+scrollLeft,
        top = (winH-contH)/2+scrollTop;

    $el.css({left:left, top:top, margin: 0});
}

var httpstack = (function($) {

    function showRunning() {
        $('#stackRunning').css('visibility', 'visible');
        $('#stackIdle').css('visibility', 'hidden');
        try {
            window.top.status = $('#stackRunning').attr('alt');
        } catch (e) {}
    }
    function showIdle() {
        $('#stackRunning').css('visibility', 'hidden');
        $('#stackIdle').css('visibility', 'visible');
        try {
            window.top.status = '';
        } catch (e) {}
    }

    function process(req) {
        var xhr = $.ajax(req.target, {
            type: "POST",
            headers: req.headers,
            data: req.data
        });

        xhr.then(req.callback, function() {
            var s = xhr.status,
                fn = req.handlers && req.handlers[s];
            if (fn) {
                fn.apply(xhr, arguments);
            }
        });
        return xhr;
    }

    function stackStatusChanged() {
    }

    var processing = null;
    return {
        push: function(req) {
            if (!processing) {
                showRunning();
                processing = process(req).done(showIdle);
            } else {
                processing = processing.then(function() {
                    showRunning();
                    return process(req).done(showIdle);
                });
            }
        }
    };

})(jQuery);

function fnLadder2(e) {
    var $ladder = $(e.currentTarget).closest('.ladder'),
        $holder = $ladder.find('.nps-rungs'),
        $rungs = $holder.find('.rung'),
        $rung = $(e.currentTarget).closest('.rung');

    var oCtrl = NPSContext.get('ladder', {
        queryContext: function(queryCommand, opts) {

            switch (queryCommand) {
                case 'initialize':
                    return ($holder.data('add') !== "no") && ($rungs.length === 0);

                case 'insert':
                    return ($holder.data('add') !== "no") && ($rungs.length > 0);

                case 'delete':
                    if (($rung.data('delete')) && ($rung.data('delete').disabled)) {
                        return false;
                    }

                    return ($holder.data('delete') !== "no") && ($rungs.length>0);

                case 'move' :
                    if ($rungs.length<2) return false;

                    var delta = opts.where,
                        ix = $rungs.get().indexOf($rung.get(0));

                    if ((delta===-1)||(delta==='first')) {
                        return ix>0;
                    }
                    if ((delta===1)||(delta==='last')) {
                        return ix<($rungs.length-1);
                    }
                    break;
            }

            return false;
        },
        actions : {
            addRung: function(opts) {
                var d = $rung.data('add') || $ladder.data('init'),
                    url = $holder.data('url'),
                    data = _.clone($holder.data('well')),
                    args;

                opts = opts || {};


                $ladder.find('.action-ladder2-init').hide();

                if (d && d.action) {
                    args = _.clone(d.args);
                    _.each(d.injections, function(inj) {
                        if (inj.what==='before/after') {
                            args[inj.at] = (opts.where === -1) ? 'before':'after';
                            return;
                        }
                        if (inj.what==='function') {
                            args[inj.at] = window[inj.f];
                            return;
                        }
                    });
                    window[d.action].apply(null, args);
                } else {

                    if ($rung.length) {
                        data.position = (opts.where === -1) ? $rungs.index($rung) : $rungs.index($rung)+1;
                    }

                    $.post(url, data).then(function(res) {
                        var $res = $(res);
                        if ($rung.length) {
                            if (opts.where === -1)
                                $rung.before($res);
                            else
                                $rung.after($res);
                        } else {
                            $holder.append($res);
                        }
                        if (window.fnInitFields) {
                            window.fnInitFields($res);
                        }
                    });
                }
            },
            deleteRung: function() {
                var d = $rung.data('delete'),
                    action = window[d.action],
                    args = _.clone(d.args);

                action.apply(null, args);

                $rung.remove();
                if (!$holder.find('.rung').length)
                    $ladder.find('.action-ladder2-init').show();
            },
            moveRung: function(opts) {
                var d = $rung.data('move'),
                    action = window[d.action],
                    args = _.clone(d.args);

                args.push(opts.where);

                _.each(d.injections, function(inj) {
                    if (inj.what==='index') {
                        args[inj.at] = $rungs.get().indexOf($rung.get(0));
                        if (opts.where === -1)
                            args[inj.at] = args[inj.at] - 1;
                        else
                            args[inj.at] = args[inj.at] + 1;
                        return;
                    }
                });

                action.apply(null, args);

                if (opts.where===-1) {
                    $rung.insertBefore($rung.prev());
                } else {
                    $rung.insertAfter($rung.next());
                }

            },
            fireRung: function(opts) {
                var event = opts.event, actions = $rung.data('callbacks'), goac;
                if (!event) return;
                if (!actions) return;
                if (!actions[event]) return;

                goac = actions[event];
                window[goac.callback].apply($rung, goac.args || []);
            }
        }
    });
    oCtrl.show({
        position: {
           left: e.pageX,
           top: e.pageY
        }
    });

    return false;
}

function npslogout() {
    window.location.href = global_rootAdmin+'/login.htm?logout=logout';
}


function fnRequireAttribute(attr, opts) {
    var dfd = $.Deferred();

    var aParameters = [
        'attr='+attr,
        'site='+global_site,
        'tag='+opts.tag
    ];

    var src = global_rootAdmin+'/edition/pages/externals/attr/index.htm?'+aParameters.join('&');
    var $ext = $("<iframe src='"+src+"' class='externalDefinition'></iframe>");
    $ext.appendTo('body');
    $ext.show();
    recenterElement($ext);

    $ext.on('change', function(e, t) {
        dfd.resolve(t);
    });
    $ext.on('close', function() {
        $ext.off();
        $ext.remove();
    });

    var $ov = $('<div class="overlayed"></div>').appendTo('body');
    $ov.on('mousedown', function(e) {
        e.stopPropagation();

        $ov.remove();
        $ext.off();
        $ext.remove();
        dfd.reject();
    });

    return dfd.promise();
}

function fnRequireTitle(opts) {
    var dfd = $.Deferred();

    var aParameters = [
        'site='+global_site,
        'tag='+opts.tag
    ];

    var src = global_rootAdmin+'/edition/pages/externals/title/index.htm?'+aParameters.join('&');
    var $ext = $("<iframe src='"+src+"' class='externalDefinition'></iframe>");
    $ext.appendTo('body');
    $ext.show();
    recenterElement($ext);

    var title = opts.title || '';
    $ext.on('title:changed', function(e, t) {
        title = t;
        dfd.resolve(title);
    });
    $ext.on('close', function() {
        $ext.off();
        $ext.remove();
    });

    var $ov = $('<div class="overlayed"></div>').appendTo('body');
    $ov.on('mousedown.fnRequireTitle', function(e) {
        e.stopPropagation();

        $ov.remove();
        $ext.off();
        $ext.remove();
        dfd.reject();
    });

    return dfd.promise();
}


$(document).ready(function() {
    $('body').on('mousedown', '.editr',  function(e) {
        e.stopPropagation();

        var $el = $(this);
        TextEditor.rise($el, e);
        $('body').trigger('tremor');
    });



    $('body').on('focus', '.editrfocus',  function() {
        var $el = $(this).next('.editr');
        TextEditor.rise($el);
        $('body').trigger('tremor');
        return false;
    });

    $(window).on('message',  function(e) {
        if (e.originalEvent.data==='quake');
            $('body').trigger('quake');
    });

    $('body').on('click', '.editr a',  function(e) {
        e.preventDefault();
    });

    $(window).on('mousedown',  function(e) {
        $('body').trigger('quake');
    });

    $('body').on('contextmenu', '.editr-paragraph',  function(e) {
        var Ted = TextEditor, $el = $(this), ctxdata = $el.data('context') || {};
        e.preventDefault();

        Ted.rise($el);
        Ted.editing.selectionSave();

        var oCtrl = NPSContext.get('paragraph', {
            owner: Ted.editing,
            queryContext: function(s) {
                return Ted.editing.queryCommand(s);
            },
            actions: function(action, opts) {
                var copyed = Ted.editing;

                switch (action) {
                    case 'link':
                        var n = copyed.queryNode('a'),
                            $holder=$(n);

                        var site = window.global_site,
                            documentId = window.global_documentId
                        ;
                        try {
                            site = window.top.global_site;
                            documentId = window.top.global_documentId;
                        } catch (e) {}


                        var ed = window.NPS.Views.LinkEdit.create('#external_link', {
                            root: window.global_rootAdmin,
                            data: {
                                site: site,
                                titled: true,
                                title: $holder.attr('title'),
                                linkId: $holder.attr('descriptor'),
                                documentId: documentId,
                                srchref: $holder.attr('href')
                            },
                            done: function(link) {
                                var d = _.extend({}, opts, link);
                                copyed.selectionRestore();
                                copyed.applyCommand('setlink', d);
                            }
                        });
                        ed.show();
                    break;
                    default:
                        copyed.selectionRestore();
                        var theed = copyed.applyCommand(action, opts);

                        if (opts && opts.titled) {
                            window.fnRequireTitle({
                                title: theed.attr(opts.titled),
                                tag: opts.tag
                            }).then(function(title) {
                                theed.attr(opts.titled, title);
                            });
                        }
                        if (opts && opts.attr) {
                            window.fnRequireAttribute(opts.attr, {
                                value: theed.attr(opts.attr),
                                tag: opts.tag
                            }).then(function(val) {
                                theed.attr(opts.attr, val);
                            });
                        }
                    break;
                }
                oCtrl.hide();
            }

        });

        oCtrl.show({
            shielded: true,
            position: {
               left: e.pageX,
               top: e.pageY
            },
            width: 200,
            replace : {
                styles: {
                    src : (ctxdata.styles) ? '#'+ctxdata.styles : null
                }
            }
        });

        return false;
    });


    $('body').on('contextmenu', '.editr-richtext',  function(e) {
        var Ted = TextEditor, $el = $(this), ctxdata = $el.data('context') || {};
        var disabled = ctxdata.disabled ? ctxdata.disabled.split(',') : []
        e.preventDefault();

        Ted.rise($(this));
        Ted.editing.selectionSave();

        var oCtrl = NPSContext.get('richtext', {
            owner: Ted.editing,
            queryContext: function(sFormatString, opts) {
                if (disabled.includes(sFormatString)) {
                    return false
                }

                return Ted.editing.queryCommand(sFormatString, opts);
            },
            actions: function(action, opts) {
                var copyed = Ted.editing;

                switch (action) {
                    case 'link':
                        var n = copyed.queryNode('a'),
                            $holder=$(n);


                        var site = window.global_site,
                            documentId = window.global_documentId
                        ;
                        try {
                            site = window.top.global_site;
                            documentId = window.top.global_documentId;
                        } catch (e) {}

                        var ed = window.NPS.Views.LinkEdit.create('#external_link', {
                            root: window.global_rootAdmin,
                            data: {
                                site: site,
                                titled: true,
                                title: $holder.attr('title'),
                                linkId: $holder.attr('descriptor'),
                                documentId: documentId,
                                srchref: $holder.attr('href')
                            },
                            done: function(link) {
                                var d = _.extend({}, opts, link);
                                copyed.selectionRestore();
                                copyed.applyCommand('setlink', d);
                            }
                        });
                        ed.show();
                    break;
                    default:
                        Ted.editing.selectionRestore();
                        var theed = Ted.editing.applyCommand(action, opts);

                        if (opts && opts.titled) {
                            window.fnRequireTitle({
                                title: theed.attr(opts.titled),
                                tag: opts.tag
                            }).then(function(title) {
                                theed.attr(opts.titled, title);
                            });
                        }

                        if (opts && opts.attr) {
                            window.fnRequireAttribute(opts.attr, {
                                value: theed.attr(opts.attr),
                                tag: opts.tag
                            }).then(function(val) {
                                theed.attr(opts.attr, val);
                            });
                        }


                    break;
                }
                oCtrl.hide();
            }

        });
        oCtrl.show({
            shielded: true,
            position: {
               left: e.pageX,
               top: e.pageY
            },
            replace : {
                styles: {
                    src : (ctxdata.styles) ? '#'+ctxdata.styles : null
                }
            }
        });

        return false;
    });


    $('body').on('click contextmenu', '.nps-context-call',  function(e) {
        e.preventDefault();
        var $el = $(e.currentTarget), info = $el.data('contexted'), ctx, show;

        ctx = info.context;
        show = (info.position) ?
            {position: info.position, element: $el} :
            {position: {left: e.pageX, top: e.pageY}};

        var oCtrl = NPSContext.get(info.context);
        oCtrl.show(show);
    });


    $('#pbody').on('click', '.treeSelect [toggling="true"]', function(e) {
        var $el = $(e.currentTarget),
            $tree = $el.closest('.treeSelect'),
            selector = $tree.attr('sharedClass'),
            callinfo = $tree.data('onchange');

        e.preventDefault();

        $tree.find('[toggling="true"]').removeClass(selector);
        $el.addClass(selector);

        var f = window[callinfo.callback];
        f(_.extend({}, callinfo.data, {
            value: $el.attr('value')
        }));
    });


    $('body').on('click', '._toggler_action',  function(e) {
        e.preventDefault();
        var $target = $(this).closest('._toggler').find('._toggler_target');
        $target.toggleClass('_on');
    });

    $('#header-wrapper').css({
        height: $('#header').height()+'px'
    });

    // gestion du menu
    $('#menu').on('click', '[data-menu]', function(e) {
        e.stopPropagation();
        HierarchyMenu.show($(this).data('menu'));
    });
    $('#menu').on('mouseenter', '[data-menu]', function(e) {
        HierarchyMenu.preload($(this).data('menu'));
    });

    $('html,body').on('click', function() {
        HierarchyMenu.hide();
    });

    $('body').on('click', '.logout', npslogout);
    $('body').on('click', '.aboutme', function() {
        window.location.href = global_rootAdmin+'/users/me.htm';
    });

    $('body').on('click', "button[data-role='toggle']", function() {
        var $bt = $(this),
            $target = $($bt.data('target'));

        if ($bt.data('class')) {
             $target.toggleClass($bt.data('class'));
        }
    });

    $('body').on('mouseover', ".tableButton", function() {
        $(this).addClass('tableButtonOver');
        $(this).removeClass('tableButton');
    });
    $('body').on('mouseout', ".tableButtonOver", function() {
        $(this).removeClass('tableButtonOver');
        $(this).addClass('tableButton');
    });


    $('body').on('click', '[role="tab"]', function() {
        var $button = $(this),
            $buttons = $button.closest('[role="tablist"]'),
            activate = $button.attr('aria-controls')
        ;
        $buttons.find('[aria-controls]').each(function() {
            var
                $el = $(this),
                tg = $el.attr('aria-controls'),
                $tab = $('#'+tg)
            ;
            if (tg === activate) {
                $el.attr('aria-selected',  'true');
                $tab.attr('aria-hidden',  'false');
            } else {
                $el.attr('aria-selected',  'false');
                $tab.attr('aria-hidden',  'true');
            }
        });



    });



});